import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
// tslint:disable-next-line: no-submodule-imports
import { FaTrash } from 'react-icons/fa';

import { Paginated } from '../../../../adl-gen/common';
import { DbKey, WithDbId } from '../../../../adl-gen/common/db';
import { Competency, Skill } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { LangCode, withI18n, WithI18nProps } from '../../../../internationalization/i18n-hoc';
import { EditIcon, PlusIcon } from '../../../../ui/common/icons';
import { Button } from '../../../../ui/widgets/button/button';
import { Select, SelectOption } from '../../../../ui/widgets/select/select';
import { ListEntryWithIdentity } from '../../common/list/list-types';
import { DisplayI18nText, DisplayText } from '../../common/editor';
import { ListView } from '../../common/list/list-view';
import { SkillListView } from '../lists/skill-lists/skill-list-view';

const styles = require('../../common/details-view.css');
const commonStyles = require('../../common/common.css');

interface CompetencyDetailsViewProps extends WithI18nProps {
  competency: WithDbId<Competency>;
  skills: Paginated<ListEntryWithIdentity<Skill>>;
  onUpdate(competencyId: DbKey<Competency>): Promise<void>;
  onCreateSkill(competencyId: DbKey<Competency>): void;
  onSelectSkill(competencyId: DbKey<Competency>): Promise<void>;
  role: 'super';
}

/// Make observer for the LangSelector/WithI18n HOC
@observer
class CompetencyDetailsView0 extends React.Component<CompetencyDetailsViewProps> {
  /// Language management
  @observable lang: LangCode = this.props.currentLangCode();

  @action
  changeLang = (opt: SelectOption) => {
    this.lang = opt.value as LangCode;
  };

  LangSelector = observer(() => {
    const { i18nOptions } = this.props;
    const onChange = this.changeLang;
    const options = i18nOptions();
    return (
      <Select
        options={options}
        defaultValue={options.find(option => (option.value as LangCode) === this.lang)}
        onChange={onChange}
      />
    );
  });

  /// Sort this out later
  private readonly deleteAllowed: boolean = false;

  Name = DisplayI18nText({
    field: this.props.competency.value.name,
    lang: this.lang,
    title: 'Short Name',
    xsSpan: 2
  });
  FullName = DisplayI18nText({
    field: this.props.competency.value.fullName,
    lang: this.lang,
    title: 'Full Name',
    xsSpan: 2
  });
  Definition = DisplayI18nText({
    // observer((lang) =>
    field: this.props.competency.value.definition,
    lang: this.lang,
    title: 'Definition',
    xsSpan: 4
  });
  // );
  Ordering = DisplayText({
    field: this.props.competency.value.ordering,
    title: 'Ordering',
    xsSpan: 2
  });

  /// TODO Replace all these divs with a flexbox and flex items
  renderTopButtons = () => {
    const updateButton = () => {
      return (
        <div className={commonStyles.buttonList}>
          <Button
            onClick={async () => this.props.onUpdate(this.props.competency.id)}
            Icon={EditIcon}
            size="small"
            variant="round"
          >
            Update
          </Button>
        </div>
      );
    };

    const deleteButton = () => {
      return (
        <div className={commonStyles.buttonList}>
          <Button
            Icon={FaTrash}
            size="small"
            variant="round"
          >
            Delete
          </Button>
        </div>
      );
    };

    return (
      <div className={commonStyles.buttonListContainer}>
        {this.deleteAllowed && deleteButton()}
        {updateButton()}
      </div>
    );
  };

  renderNewSkillButton = () => {
    const newSkillButton = () => {
      return (
        <div className={commonStyles.buttonList}>
          <Button
            onClick={async () => this.props.onCreateSkill(this.props.competency.id)}
            Icon={PlusIcon}
            size="small"
            variant="round"
          >
            New Skill
          </Button>
        </div>
      );
    };

    return <div className={commonStyles.buttonListContainer}>{newSkillButton()}</div>;
  };

  /// TODO: LangSelector isn't working, because the displayI18nText are not observers and not reacting to actions
  renderDetails = (
    <React.Fragment>
      <div>
        {this.renderTopButtons()}
      </div>
      <div className={styles.row}>
        {this.Name}
        {this.FullName}
      </div>
      <div className={styles.row}>{this.Definition}</div>
      <div className={styles.row}>{this.Ordering}</div>
    </React.Fragment>
  );

  renderSkillList = (
    <React.Fragment>
      <div>
        <h4>Skills</h4>
        {this.renderNewSkillButton()}
      </div>
      <div className={styles.row}>
        <ListView
          list={this.props.skills}
          fields={SkillListView}
          onSelect={this.props.onSelectSkill}
        />
      </div>
    </React.Fragment>
  );

  render() {
    const {
      competency
    } = this.props;
    if (competency) {
      return (
        <React.Fragment>
          <div className={styles.page}>
            <div className={styles.body}>
              <div className={styles.row}>{this.renderDetails}</div>
            </div>
            <div className={styles.body}>
              <div className={styles.row}>{this.renderSkillList}</div>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return null;
    }
  }
}

export const CompetencyDetailsView = withI18n(CompetencyDetailsView0);



// WEBPACK FOOTER //
// ./src/admin/ui/components/detail-views/competency-details-view.tsx